export const Direction = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;
export type Direction = (typeof Direction)[keyof typeof Direction];
